<template>
  <div class="d-flex w-100 no-item-container">
    <div class="m-auto">
      <div
        class="d-flex justify-content-center no-img-table-render"
        :style="customCss"
      >
        <img class="h-80" :src="NoItemImg" alt="" draggable="false" />
      </div>
      <div class="empty-color text-center mt-btn">
        <lucky-draw-button
          :isShowIconAdd="isShowIconAdd"
          :isShowIconDown="isShowIconDown"
          :btn-label="textNoImg"
          :is-disabled="isDisabled"
          @click.native="actionFunc"
        />
      </div>
    </div>
  </div>
</template>

<script>
import NoItemImg from "@/assets/images/artwork/no-inventory.png";

import { computed } from "@vue/composition-api";
import LuckyDrawButton from "@/views/components/button/LuckyDrawButton.vue";

export default {
  components: {
    LuckyDrawButton,
  },
  props: {
    textNoImg: String,
    height: Number,
    actionFunc: { type: Function, default: () => {} },
    isDisabled: { type: Boolean, default: false },
    isShowIconAdd: { type: Boolean, default: false },
    isShowIconDown: { type: Boolean, default: false },
  },
  setup(props) {
    const customCss = computed(() => ({
      height: props.height ? `${props.height}px` : "300px",
    }));

    return {
      NoItemImg,
      customCss,
    };
  },
};
</script>

<style scoped>
@import "~@/assets/css/override-styles/card-no-item.css";

.btn-customClass {
  padding: 0.5rem 0.8rem !important;
  font-size: 22px;
}

.mt-btn {
  margin-top: -4rem;
}
</style>
